import React, { useState, useEffect } from 'react';
import {
  Col,
  Row,
  Button,
  Container,
  Accordion,
  Tab,
  Nav,
} from '@themesberg/react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';

import CustomErrorView from '../../components/CustomErrorView';
import CustomDashboardLoader from '../../components/CustomDashboardLoader';
import {
  clearIndividualSahakari,
  getSahakariById,
} from '../../redux/actions/sahakari';

const Labels = (key, value) => {
  return (
    <div className='d-flex mb-3'>
      <h6>{key}: </h6>
      <span>&nbsp;</span>
      <h6>{value ?? 'N/A'}</h6>
    </div>
  );
};

function SahakariDetails({ match, history }) {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [showErrPage, setShowErrPage] = useState(false);

  const individualSahakari = useSelector(
    (state) => state.sahakari.individualSahakari
  );

  const handleSuccess = () => setIsLoading(false);

  const handleFailure = () => {
    setIsLoading(false);
    setShowErrPage(true);
  };
  useEffect(() => {
    const someId = match.params?.id;
    if (!someId) {
      setShowErrPage(true);
    } else {
      setIsLoading(true);
      dispatch(getSahakariById(someId, handleSuccess, handleFailure));
    }
    return () => {
      dispatch(clearIndividualSahakari());
    };
  }, []);

  if (showErrPage) {
    return <CustomErrorView />;
  } else {
    return (
      <div>
        {isLoading ? (
          <CustomDashboardLoader />
        ) : (
          <div className='bg-soft'>
            <Container>
              <Accordion defaultActiveKey='0'>
                <Accordion.Item eventKey='0'>
                  <Accordion.Header>Sahakari Details</Accordion.Header>
                  <Accordion.Body>
                    <Row className=' d-flex' style={{ alignItems: 'center' }}>
                      <Col md={12} lg={6}>
                        <h5>{individualSahakari.name}</h5>
                      </Col>
                      <Col
                        md={12}
                        lg={6}
                        className='d-flex'
                        style={{ justifyContent: 'flex-end' }}
                      >
                        <Button
                          variant='primary'
                          onClick={() => {
                            history.push(
                              `/sahakari/edit/${individualSahakari.sahakari?.id}`,
                              {
                                message: 'asdasd',
                              }
                            );
                          }}
                        >
                          Edit Sahakari
                        </Button>
                      </Col>
                      {Labels('Id', individualSahakari.sahakari?.id)}
                      {Labels(
                        'Type',
                        individualSahakari.sahakari?.mainBranch === 'SELF'
                          ? 'Main Office'
                          : `Branch of ${individualSahakari.sahakari?.mainBranch}`
                      )}
                      {Labels('Username', individualSahakari.username)}
                      {Labels('Email', individualSahakari.email)}
                      {Labels('Phone Number', individualSahakari.mobileNumber)}
                      {Labels(
                        'Location',
                        individualSahakari.sahakari?.location
                      )}
                      {Labels(
                        'Expiration Date',
                        individualSahakari.sahakari?.expirationDate
                      )}
                      {Labels(
                        'IsActive',
                        individualSahakari.sahakari?.isActive ? 'true' : 'false'
                      )}
                    </Row>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Container>
          </div>
        )}
      </div>
    );
  }
}

export default SahakariDetails;
